function dateOnly(value) {
  return value ? String(value).slice(0, 10) : '';
}

export function moveStudentDestinationClasses(classes = [], {
  sourceClassId = '',
  destinationType = 'class',
  today = new Date().toISOString().slice(0, 10)
} = {}) {
  const currentYearStart = `${today.slice(0, 4)}-01-01`;

  return classes
    .filter((item) => {
      if (item.id === sourceClassId) return false;
      const classDate = dateOnly(item.class_date);
      if (!classDate || classDate < currentYearStart) return false;

      if (destinationType === 'holding_tank') {
        const searchable = [item.class_name, item.class_code, item.location, item.notes]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return searchable.includes('holding') || searchable.includes('tank');
      }

      if (destinationType === 'future_class') return classDate >= today;
      return true;
    })
    .sort((left, right) => {
      const dateComparison = dateOnly(right.class_date).localeCompare(dateOnly(left.class_date));
      if (dateComparison) return dateComparison;
      const timeComparison = String(right.class_time || '').localeCompare(String(left.class_time || ''));
      if (timeComparison) return timeComparison;
      return String(left.class_name || '').localeCompare(String(right.class_name || ''));
    });
}
